import React, { useMemo } from "react"
import ReactWordcloud from 'react-wordcloud';
import useStore from "../../utils/useStore";

const WordComponent = React.memo(({ item, isFullScreen, answers, isLive }) => {
    const selects = useStore((state) => state.selects)
    const selected = selects?.find((e) => e === item?.id)
    const editElements = useStore((state) => state.editElements)
    const addSelects = useStore((state) => state.addSelects)
    const setClickedPosition = useStore((state) => state.setClickedPosition)
    const setDragging = useStore((state) => state.setDragging)
    const dragging = useStore((state) => state.dragging)
    const setResizing = useStore((state) => state.setResizing)
    const resizing = useStore((state) => state.resizing)
    const editing = useStore((state) => state.editing)
    const setEditing = useStore((state) => state.setEditing)

    const onMouseDown = (event) => {
        window.getSelection().removeAllRanges()
        if (selected) {
            //selects?.length > 1 || 
        } else if (event?.shiftKey) {
            addSelects(item?.id, true)
        } else {
            addSelects(item?.id)
        }
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        setClickedPosition({ x: event.clientX, y: event.clientY })
        if (!selected && editing) {
            setEditing(false)
            setTimeout(() => {
                setDragging(true)
            }, 50);
        } else if (!selected) {
            setDragging(true)
        }
    }

    const onMouseHandleDown = (event, cursor, side) => {
        event.stopPropagation()
        window.getSelection().removeAllRanges()
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        setResizing({ cursor: cursor, side })
        setClickedPosition({ x: event.clientX, y: event.clientY })
    }

    return (
        <div className={selected && !isFullScreen ? 'Presentation_Inter_Select Presentation_Inter_Selected' : 'Presentation_Inter_Select'} style={{ position: "absolute", transform: `translate(${item?.currPosition?.x}px, ${item?.currPosition?.y}px)`, pointerEvents: isFullScreen ? "none" : "", cursor: resizing ? resizing?.cursor : dragging ? "move" : "default", userSelect: "none" }} onMouseDown={onMouseDown} onClick={(event) => {
            event.stopPropagation()
            if (!selected) {
                addSelects(item?.id)
            }
        }}>
            <div style={{ ...item?.style, overflow: "hidden", pointerEvents:"none" }}>
                <div className="Presentation_Inter_Title">{item?.title}</div>
                <div style={{width:"100%", height:"calc(100% - 35px)", marginTop:10}}>
                    <WordCloud allAnswers={answers} isFullScreen={isLive}/>
                </div>
            </div>
            {selected && !dragging && !isFullScreen ?
                <>
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LT' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "top-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LB' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "bottom-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RT' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "top-right")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RB' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "bottom-right")} />
                </>
                : null}
        </div>
    )
})

const WordCloud = React.memo(({ allAnswers, isFullScreen }) => {
    
    const answers = allAnswers?.length > 0? allAnswers?.reduce((acc, { answer }) => {
        const existingAnswer = acc.find(item => item.text.toLowerCase() === answer.toLowerCase());

        if (existingAnswer) {
          existingAnswer.value++;
        } else {
          acc.push({ text: answer, value: 1 });
        }
        
        return acc;
    }, []) : []
    
    const words = [
        {
            text: 'Pizza',
            value: 92,
        },
        {
            text: 'Memes',
            value: 75,
        },
        {
            text: 'Netflix',
            value: 85,
        },
        {
            text: 'Food!',
            value: 78,
        },
        {
            text: 'Blank',
            value: 80,
        },
        {
            text: 'Cats',
            value: 67,
        },
        {
            text: 'Oopsie',
            value: 72,
        },
        {
            text: 'Brainfreeze',
            value: 65,
        },
        {
            text: 'Overthinking',
            value: 60,
        },
        {
            text: 'Recharge',
            value: 82,
        },
        {
            text: 'House',
            value: 90,
        },
        {
            text: 'Monday',
            value: 88,
        },
        {
            text: 'Ghosted',
            value: 84,
        },
        {
            text: 'Deadline',
            value: 76,
        },
        {
            text: '404 Brain Not Found',
            value: 70,
        },
        {
            text: 'Chaos',
            value: 66,
        },
    ]
    return <ReactWordcloud options={{ rotations: 2, rotationAngles: [-90, 0], fontSizes: [18, 60] , colors:["#ec1d00", "#5d6e00", "#6b0117", "#f7a000"], fontFamily: `"Sora", sans-serif`, transitionDuration: isFullScreen? 1000 : 0 }} words={isFullScreen? answers : words} />
})

export default WordComponent;

// Pizza

// Memes

// WiFi

// Coffee

// Cats

// Sleep

// Procrastinate

// Brainfreeze

// Oops

// LOL

// Netflix

// Binge

// Snack

// Why?

// Sarcasm

// Help!

// Monday

// Weekend?

// Overthinking

// Blank

// Mood

// Unsubscribe

// Recharge

// Meh

// Oopsie

// Ctrl+Z

// Ghosted

// Snooze

// 404 Brain Not Found

// Nap Mode

// Deadline?

// Food!

// Chaos

// Doomscroll

// Autocorrect

// Oops, Again

// No Thoughts, Just Vibes